/**
 * Womens multi-column size dropdown.
 */
if (!window.WomensSizeSelect) {
  const WomensSizeSelect = {
    placeholder: 'Select Size',

    updateButtonLabel(customSelect, option) {
      const label = customSelect.querySelector('.womens-size-select__btn-label');
      if (!label) return;

      if (!option || option.dataset.value === '') {
        label.textContent = this.placeholder;
        label.classList.remove('womens-size-select__btn-label--has-cols');
        return;
      }

      const cols = option.querySelector('.womens-size-select__cols');
      if (!cols) return;

      const isUnavailable = option.classList.contains('is-unavailable')
        || option.classList.contains('womens-size-select__option--unavailable');

      label.innerHTML = cols.cloneNode(true).outerHTML;
      label.classList.add('womens-size-select__btn-label--has-cols');

      const colsEl = label.querySelector('.womens-size-select__cols');
      colsEl?.classList.add('womens-size-select__cols--button');

      const actionCol = label.querySelector('.womens-size-select__col--action');
      if (isUnavailable && actionCol) {
        actionCol.querySelector('.womens-size-select__notify')?.remove();
        actionCol.textContent = 'Out of stock';
        colsEl?.classList.add('womens-size-select__cols--oos');
      } else {
        actionCol?.remove();
      }
    },

    clearPendingState(container, variant) {
      container?.querySelectorAll('.womens-size-pending-restore').forEach((btn) => btn.remove());

      if (variant && !variant.available) {
        container?.querySelectorAll('.klaviyo-bis-trigger').forEach((btn) => {
          btn.hidden = false;
          btn.removeAttribute('aria-hidden');
          btn.disabled = false;
        });
      }
    },

    enforcePendingState(container) {
      if (!container?.classList.contains('womens-size-pending')) {
        container?.querySelectorAll('.womens-size-pending-restore').forEach((btn) => btn.remove());
        return;
      }

      if (container.dataset.womensEnforcing === 'true') return;
      container.dataset.womensEnforcing = 'true';

      try {
        container.querySelectorAll('.klaviyo-bis-trigger').forEach((btn) => {
          if (!btn.hidden) btn.hidden = true;
          if (btn.getAttribute('aria-hidden') !== 'true') btn.setAttribute('aria-hidden', 'true');
          if (!btn.disabled) btn.disabled = true;
        });

        let addBtn = container.querySelector('.add-to-cart[name="add"]:not(.womens-size-pending-restore)');
        if (!addBtn) {
          const submitRow = container.querySelector('.quantity-submit-row__submit');
          if (submitRow && !submitRow.querySelector('.womens-size-pending-restore')) {
            addBtn = document.createElement('button');
            addBtn.type = 'submit';
            addBtn.name = 'add';
            addBtn.className = 'btn btn--large add-to-cart womens-size-pending-restore';
            addBtn.textContent = container.dataset.addToCartText || 'Add to Cart';
            addBtn.disabled = true;
            submitRow.appendChild(addBtn);
          }
        }

        if (addBtn) {
          addBtn.hidden = false;
          addBtn.disabled = true;
          const label = addBtn.dataset.addToCartText || container.dataset.addToCartText || 'Add to Cart';
          if (addBtn.textContent !== label) addBtn.textContent = label;
        }
      } finally {
        delete container.dataset.womensEnforcing;
      }
    },

    schedulePendingCheck(container) {
      if (!container?.classList.contains('womens-size-pending')) return;
      window.clearTimeout(container._womensPendingTimer);
      container._womensPendingTimer = window.setTimeout(() => {
        this.enforcePendingState(container);
      }, 300);
    },

    initSelect(customSelect) {
      if (customSelect.dataset.womensInit === 'true') return;
      customSelect.dataset.womensInit = 'true';

      const selected = customSelect.querySelector('.custom-select__option[aria-selected="true"]');
      if (!selected || selected.dataset.value === '') {
        this.updateButtonLabel(customSelect, null);
      } else {
        this.updateButtonLabel(customSelect, selected);
      }
    },

    initAll() {
      document.querySelectorAll('custom-select.womens-size-select').forEach((customSelect) => {
        this.initSelect(customSelect);
      });

      document.querySelectorAll('.product-form.womens-size-pending').forEach((container) => {
        this.enforcePendingState(container);
        this.schedulePendingCheck(container);
      });
    }
  };

  window.WomensSizeSelect = WomensSizeSelect;

  document.addEventListener('click', (evt) => {
    const notifyBtn = evt.target.closest('.womens-size-select__notify');
    if (notifyBtn) {
      evt.preventDefault();
      evt.stopPropagation();

      const option = notifyBtn.closest('.custom-select__option');
      const customSelect = notifyBtn.closest('custom-select.womens-size-select');
      if (!option || !customSelect || typeof customSelect.selectOption !== 'function') return;

      customSelect.selectOption(option);
      WomensSizeSelect.updateButtonLabel(customSelect, option);

      window.setTimeout(() => {
        document.querySelector('.product-form:not(.womens-size-pending) .klaviyo-bis-trigger')?.click();
      }, 150);
      return;
    }

    const option = evt.target.closest('.womens-size-select__option');
    if (!option || evt.target.closest('.womens-size-select__notify')) return;

    const customSelect = option.closest('custom-select.womens-size-select');
    if (!customSelect || typeof customSelect.selectOption !== 'function') return;

    if (evt.target.tagName !== 'LI') {
      customSelect.selectOption(option);
      WomensSizeSelect.updateButtonLabel(customSelect, option);
    }
  });

  document.addEventListener('change', (evt) => {
    const customSelect = evt.target.closest?.('custom-select.womens-size-select')
      || (evt.target.matches?.('custom-select.womens-size-select') ? evt.target : null);
    if (!customSelect) return;

    const selected = customSelect.querySelector('.custom-select__option[aria-selected="true"]');
    WomensSizeSelect.updateButtonLabel(customSelect, selected);
  });

  document.addEventListener('DOMContentLoaded', () => {
    WomensSizeSelect.initAll();
    window.setTimeout(() => WomensSizeSelect.initAll(), 800);
  });

  document.addEventListener('shopify:section:load', () => {
    WomensSizeSelect.initAll();
  });
}
